import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CustomerServiceService } from '../services/customer-service.service';
import { SnackBarService } from '../services/snack-bar.service';

@Component({
  selector: 'app-download-model',
  templateUrl: './download-model.component.html',
  styleUrls: ['./download-model.component.css']
})
export class DownloadModelComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { customerId: number; customer_type?: string },
    private dialogRef: MatDialogRef<DownloadModelComponent>,
    private router: Router,
    private customerService: CustomerServiceService,
    private snackBarService: SnackBarService
  ) { }

  ngOnInit(): void { }

  sendViaEmail(): void {
    this.customerService.sendMail(this.data.customerId).subscribe((response) => {
      this.snackBarService.openSnackBar(response.data, 'success-class');
    });
  }

  /** Close the dialog and navigate to the correct list based on customer type */
  goToList(): void {
    const target = this.data.customer_type === 'vip_customer'
      ? '/vip-customer-list'
      : '/dashboard/customer-list';
    this.dialogRef.close();
    this.router.navigate([target]);
  }

  downloadPdf(): void {
    window.location.href = `${environment.BASE_URL}/customers/pdf/${this.data.customerId}`;
  }

}
